// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0GcLE","footnote":"styles_footnote__778pB","grayText":"styles_grayText__cb37h","tableWrapper":"styles_tableWrapper__dhP1q"};